import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { createBrowserHistory } from "history";
import { routerMiddleware } from 'connected-react-router'

import createRootReducer from './reducers'

export let history = createBrowserHistory();

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ["router"]
};

const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

const composeEnhansers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })
    :
    compose;
export let store = createStore(
    persistedReducer,
    composeEnhansers(applyMiddleware(thunk, routerMiddleware(history))));

export let persistor = persistStore(store);

